import { render, staticRenderFns } from "./IvanPager.vue?vue&type=template&id=4e3114b6"
import script from "./IvanPager.vue?vue&type=script&lang=js"
export * from "./IvanPager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports